import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ChatInterface } from "./components/ChatInterface";
import { AdminPage } from "./pages/AdminPage";
import ProviderDashboard from "./pages/ProviderDashboard";
import TravelPassPage from "./pages/TravelPassPage";
import IlMioViaggio from "./pages/IlMioViaggio";
import VerifyPage from "./pages/VerifyPage";
import SmokeTestPage from "./pages/SmokeTestPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ChatInterface />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/provider" element={<ProviderDashboard />} />
          <Route path="/fornitori" element={<ProviderDashboard />} />
          <Route path="/resume/:token" element={<ChatInterface />} />
          <Route path="/viaggio/:code" element={<TravelPassPage />} />
          <Route path="/il-mio-viaggio/:code" element={<IlMioViaggio />} />
          <Route path="/verify" element={<VerifyPage />} />
          <Route path="/smoketest" element={<SmokeTestPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
